import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
} from "@mui/material";
import ApiService from "../../_services/ApiService";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import playlist from "../../img/default-image.png";
import NoResults from "../../_helpers/reusablefunctions/NoResults";
import SkeletonCard from "../../_helpers/reusablefunctions/SkeletonCard";
import { useHistory, useLocation } from "react-router-dom";
import PaginationComponent from "../../_helpers/reusablefunctions/paginationComponent";
import useSnackDispatcher from "../../_helpers/reusablefunctions/snackBarComponent";
import { formSnackbar } from "../../_services/_constants/snackbar.constant";
import SnackbarContainer from "../Snackbar";
import DiscoverableTabs from "../../_helpers/reusablecomponents/discoverableTabs";
import CardComponent from "../../_helpers/reusablecomponents/commonCards";

const discoverTabs = [
  { label: "all", value: ["All Music"] },
  { label: "trending", value: ["Trending Song"] },
  { label: "artist", value: ["Trending Artist"] },
  { label: 'discover-song-list', value: ['Song Promotion'] },
];
export default function DiscoverMusic() {
  const { successSnack, errorSnack, warningSnack, infoSnack } =
    useSnackDispatcher();
  const history = useHistory();
  const location = useLocation();
  const [playlistData, setPlaylistData] = useState([]);
  const [loader, setLoader] = useState(true);
  const [activeChip, setActiveChip] = useState(location?.state ? location?.state?.value : "0-0");
  const [activeLabel, setActiveLabel] = useState(location?.state ? location?.state?.label : "all");
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(20);
  const [total_count, setTotal_count] = useState(0);
  const [searchInput, setSearchInput] = useState(null);
  const [selectedTab, setSelectedTab] = useState(location?.state ? location?.state?.value : "all");

  function playlistCall(value) {
    setLoader(true);
    let searchValue = value === "artist" ? "" : value;
    let trending_artists = value === "artist" ? "true" : "";
    let pageValue = page;
    let payload;
    let apiEndpoint;

    if (value === "promotion") {
      apiEndpoint = "promotion_songs";
      payload = {
        limit,
        offset: pageValue,
      };
    } else if (value === "discover-song-list") {
      apiEndpoint = "discoverSongList";
      payload = {
        limit,
        offset: pageValue,
      };
    } else {
      apiEndpoint = "search_allsongs";
      payload =
        value !== "all"
          ? {
            promotion: false,
            search: searchValue,
            trending_artists,
            limit,
            offset: pageValue,
          }
          : {
            promotion: false,
            premium_users: "True",
            limit,
            offset: pageValue,
          };
    }

    ApiService.get(apiEndpoint, payload)
      .then((response) => {
        if (response.status === 200) {
          let arrayData = response.data.results;
          const data = arrayData.sort(
            (a, b) =>
              parseInt(a.trending_song_order) - parseInt(b.trending_song_order)
          );
          setPlaylistData(data);
          setTotal_count(response?.data?.total_count);
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setLoader(false);
      });
  }

  const handleChipClick = (i, label) => {
    setActiveChip(i);
    setActiveLabel(label);
    playlistCall(label);
    history.push(`?tab=${label}`, { value: i, label: label });
  };

  const trendingplaylist = (data) => {
    let payload =
      activeLabel !== "trending" ? { type: "trending" } : { type: "" };
    infoSnack(
      activeLabel !== "trending"
        ? formSnackbar.playlist.songTrendingAdding
        : formSnackbar.playlist.songTrendingRemove
    );
    ApiService.put("createSongList", payload, { id: data.id })
      .then((res) => {
        if (res.status == "200") {
          successSnack(
            activeLabel !== "trending"
              ? formSnackbar.playlist.songTrendingAdding
              : formSnackbar.playlist.songTrendingRemove
          );
          playlistCall(activeLabel);
        }
      })
      .catch((error) => {
        errorSnack(formSnackbar.errors.errorMsg);
        console.log(error);
      });
  };

  // ----------------- DRAG AND DROP FUNCTION -------------

  function handleOnDragEnd(result) {
    if (!result.destination) return;
    const items = Array.from(playlistData);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setPlaylistData(items);
    const data = items.map((song) => song.id);
    let dataObj = {
      song_ids: data.join(","),
    };
    ApiService.put("songTrendSequence", dataObj)
      .then((res) => {
        if (res.status == "200") {
        }
      })
      .catch((error) => {
        errorSnack(formSnackbar.errors.errorMsg);
        console.log(error);
      });
  }

  // --------------- GENERE SEARCH FUNCTION ---------------

  function handleSearchInput(value) {
    setSearchInput(value);
  }
  function getSearchList() {
    if (searchInput) {
      ApiService.get("search_allsongs", {
        search: searchInput,
        limit: 25,
        offset: page,
      })
        .then((response) => {
          if (response.status == "200") {
            setPlaylistData(response?.data?.results);
            setTotal_count(response?.data?.total_count);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      playlistCall(activeLabel);
    }
  }
  useEffect(() => {
    let delaySearch;
    delaySearch = setTimeout(() => {
      getSearchList();
    }, 1000);
    return () => clearTimeout(delaySearch);
  }, [page, limit, searchInput]);

  const openDetails = (data) => {
    if (activeLabel == "artist") {
    } else {
      history.push("/music-detail", { musicPlatformData: data });
    }
  };

  return (
    <Box sx={{ padding: "1rem 1rem 3rem 1rem" }}>
      <Box
        alignItems={"center"}
        display={"flex"}
        justifyContent={"space-between"}
      >
        <h2 style={{ marginLeft: "10px" }}>Discover-Music</h2>
      </Box>
      <Box mt={2}>
        <DiscoverableTabs
          discoverTabs={discoverTabs}
          activeChip={activeChip}
          activeLabel={activeLabel}
          handleChipClick={handleChipClick}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          searchValue={searchInput}
          handleSearchInput={handleSearchInput}
        />
        <Grid container spacing={2} alignItems="stretch">
          {loader ? (
            Array.from(new Array(8)).map((item, index) => (
              <Grid key={index} item xs={12} md={4} lg={3}>
                <SkeletonCard />
              </Grid>
            ))
          ) : loader === false && playlistData.length === 0 ? (
            <NoResults />
          ) : activeLabel !== "trending" ? (
            playlistData.map((data, index) => (
              <Grid key={index} item xs={12} md={4} lg={3}>
                {/* {cardContainer(data)} */}
                <CardComponent
                  data={data}
                  activeLabel={activeLabel}
                  genre={data?.genre}
                  mood={data?.mood}
                  language={data?.language}
                  name={activeLabel == "artist" ? data?.name : data.songTitle}
                  openDetails={openDetails}
                  trendingplaylist={trendingplaylist}
                  alt={activeLabel == "artist" ? data?.name : data?.songTitle}
                  image={
                    activeLabel == "artist" ? data?.avatar_url || (data?.user_avatar
                      ? `${process.env.REACT_APP_CREATORURL_MEDIA}/media/${data.user_avatar}`
                      : playlist)
                      : data?.songPoster_url ? data?.songPoster_url
                        : data.songPoster
                          ? process.env.REACT_APP_CREATORURL_MEDIA +
                          "/media/" +
                          data.songPoster
                          : data?.cover_image
                            ? process.env.REACT_APP_SONGAPIURL_MEDIA +
                            data.cover_image
                            : playlist
                  }
                  title={activeLabel == "artist" ? data?.name : data.songTitle}
                  type={data?.type}
                />
              </Grid>
            ))
          ) : (
            <DragDropContext onDragEnd={handleOnDragEnd}>
              <Droppable droppableId="characters" direction="horizontal">
                {(provided) => (
                  <Grid
                    container
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                  >
                    {playlistData.map((data, index) => (
                      <Draggable
                        key={index}
                        draggableId={index.toString()}
                        index={index}
                      >
                        {(provided) => (
                          <Grid
                            item
                            xs={12}
                            md={4}
                            lg={3}
                            paddingLeft={3}
                            paddingTop={3}
                          >
                            {/* {cardContainer(data, provided)} */}
                            <CardComponent
                              data={data}
                              activeLabel={activeLabel}
                              genre={data?.genre}
                              mood={data?.mood}
                              language={data?.language}
                              name={
                                activeLabel == "artist"
                                  ? data?.name
                                  : data.songTitle
                              }
                              openDetails={openDetails}
                              trendingplaylist={trendingplaylist}
                              alt={
                                activeLabel == "artist"
                                  ? data?.name
                                  : data?.songTitle
                              }
                              image={
                                activeLabel === "artist"
                                  ? data?.avatar_url || (data?.user_avatar
                                    ? `${process.env.REACT_APP_CREATORURL_MEDIA}/media/${data.user_avatar}`
                                    : playlist)
                                  : data.songPoster
                                    ? process.env.REACT_APP_CREATORURL_MEDIA +
                                    "/media/" +
                                    data.songPoster
                                    : data?.cover_image
                                      ? process.env.REACT_APP_SONGAPIURL_MEDIA +
                                      data.cover_image
                                      : playlist
                              }
                              title={activeLabel == "artist" ? data?.name : data.songTitle}
                              type={data?.type}
                              provided
                            />
                          </Grid>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </Grid>
                )}
              </Droppable>
            </DragDropContext>
          )}
        </Grid>
        <PaginationComponent
          setLimit={setLimit}
          setPage={setPage}
          limit={limit}
          total_count={total_count}
          page={page}
        />
        <SnackbarContainer />
      </Box>
    </Box>
  );
}
